var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product
    ? _c("div", { staticClass: "product-info" }, [
        _vm.product.title
          ? _c("h1", {
              staticClass: "product-info__title h3",
              domProps: { innerHTML: _vm._s(_vm.product.title) }
            })
          : _vm._e(),
        _c("div", { staticClass: "product-info__price" }, [
          _vm.variantTitle !== "Default Title"
            ? _c("span", {
                staticClass: "h6 product-info__variant-title",
                domProps: { textContent: _vm._s(_vm.variantTitle) }
              })
            : _vm._e(),
          _c("div", {
            staticClass: "bv-inline-ratings-widget",
            attrs: {
              "data-bv-show": "rating_summary",
              "data-bv-product-id": _vm.product.id
            }
          })
        ]),
        _vm.product.description
          ? _c("p", {
              staticClass: "product-info__excerpt body--md",
              domProps: { innerHTML: _vm._s(_vm.product.description) }
            })
          : _vm._e(),
        _vm.nutritionFactsVisible
          ? _c(
              "a",
              {
                staticClass: "product-info__nutrition-link link link--primary",
                attrs: { href: "#nutritionFactsH2", tabindex: "0" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.scrollToNutritionFacts.apply(null, arguments)
                  }
                }
              },
              [_vm._v("See Nutrition Facts")]
            )
          : _vm._e(),
        _vm.nutritionalDisclaimer
          ? _c("p", {
              staticClass: "product-info__nutritional-disclaimer body--xs",
              domProps: { textContent: _vm._s(_vm.nutritionalDisclaimer) }
            })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }